module.exports = __webpack_public_path__ + "img/card_ip_stipulation42_1.c565175d.svg";